export function hostingReducer(state, action) {
  if (action.type === "INCREMENT_WP_PRODS") {
    return {
      ...state,
      pid: state.pid + 1,
      price: state.price,
    };
  }
  if (action.type === "DECREMENT_WP_PRODS") {
    return {
      ...state,
      pid: state.pid - 1,
      price: state.price,
    };
  }
  if (action.type === "SET_CURRENT_PID") {
    return {
      ...state,
      pid: action.payload,
    };
  }
  if (action.type === "SET_PRODUCT_PRICE") {
    return {
      ...state,
      pid: state.pid,
      price: action.payload,
    };
  }
  if (action.type === "SET_PANEL_VHC_PRODS") {
    return {
      ...state,
      productPanel: action.payload,
    };
  }
  if (action.type === "SET_PRODUCT_DETAIL") {
    return {
      ...state,
      productDetails: {
        ...state.productDetails,
        gid: action.payload.gid,
        pid: action.payload.pid,
        name: action.payload.name,
        type: action.payload.type,
        price: action.payload.price,
        billingcycle: action.payload.billingcycle,
      },
    };
  }
  if (action.type === "SET_PROMO") {
    return {
      ...state,
      promo: {
        ...state.promo,
        realprice: action.payload.realprice,
        appliesto: action.payload.appliesto,
        description: action.payload.description,
        price: action.payload.price,
        type: action.payload.type,
        promocode: action.payload.promocode,
        pid: action.payload.pid,
      },
    };
  }
  if (action.type === "SET_ADDONS") {
    return {
      ...state,
      productDetails: {
        ...state.productDetails,
        addon: action.payload,
      },
    };
  }
  if (action.type === "ADD_ADDON_PRICE") {
    return {
      ...state,
      productDetails: {
        ...state.productDetails,
        priceWithAddon: state.productDetails.price + +action.payload,
      },
    };
  }

  throw Error("Unknown Action");
}

export function terminReducer(state, action) {
  switch (action.type) {
    case "ENABLE_MONTHLY":
      return {
        ...state,
        monthly: action.payload,
      };
    case "ENABLE_QUARTERLY":
      return {
        ...state,
        quarterly: action.payload,
      };
    case "ENABLE_SEMIANNUALLY":
      return {
        ...state,
        semiannually: action.payload,
      };
    case "ENABLE_ANNUALLY":
      return {
        ...state,
        annually: action.payload,
      };
    case "ENABLE_BIENNIALLY":
      return {
        ...state,
        biennially: action.payload,
      };
    case "ENABLE_TRIENNIALLY":
      return {
        ...state,
        triennially: action.payload,
      };
    default:
      return {
        ...state,
      };
  }
}
